import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.string.includes.js";
var findParentPathsFromSelectedNode = function findParentPathsFromSelectedNode(tree, selectedNode) {
  var path = [];
  for (var nodeId in tree) {
    var node = tree[nodeId];
    if (node && node.children && node.children.includes(selectedNode.id)) {
      path.unshift(node);
      var parentPaths = findParentPathsFromSelectedNode(tree, node);
      path.unshift.apply(path, _toConsumableArray(parentPaths));
      break;
    }
  }
  return path;
};
export var findPathsFromSelectedNode = function findPathsFromSelectedNode(tree, selectedNode) {
  var paths = findParentPathsFromSelectedNode(tree, selectedNode);
  paths.push(selectedNode);
  return paths;
};